export default __webpack_public_path__ + "static/media/ellipse.c3d816ea.svg";